module.exports = ".full-width {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/notas/notasdetalle/notasdetalle.component.scss
// module id = ./src/app/consulta/notas/notasdetalle/notasdetalle.component.scss
// module chunks = main